import { useEffect, useState } from 'react'
import { format, parseISO } from 'date-fns'
import { useTranslation } from 'libs'

import { StyledCardWrapper, Header, Title, Booth, Legend, LegendItem } from './styles'
import { IStatisticsCard } from './types'
import { cn } from 'utils/style'

const StatisticsCard = ({ className, start_date, end_date, booth }: IStatisticsCard) => {
	const [status, setStatus] = useState('')
	const [dotColor1, setDotColor1] = useState('bg-white')
	const [dotColor2, setDotColor2] = useState('bg-white')
	const { t } = useTranslation()

	useEffect(() => {
		const today = new Date()

		if (end_date && today > new Date(end_date)) {
			// expired
			setStatus(t('dashboard.statistics.status.expired'))
			setDotColor1('bg-cardinal')
			setDotColor2('bg-azalea')
		} else if (today < new Date(start_date)) {
			// inactive
			setStatus(t('dashboard.statistics.status.inactive'))
			setDotColor1('bg-sun')
			setDotColor2('bg-colonialWhite')
		} else {
			// active
			setStatus(t('dashboard.statistics.status.active'))
			setDotColor1('bg-apple')
			setDotColor2('bg-zahan')
		}
	}, [])

	return (
		<StyledCardWrapper className={className}>
			<Header>
				<Title>{t('dashboard.statistics.title')}</Title>
				{booth && <Booth>#{booth.number}</Booth>}
			</Header>
			<Legend>
				<LegendItem>
					<div className={cn('inline-block w-2 h-2 rounded-full', dotColor1)} />
					<span>{status}</span>
				</LegendItem>
				<LegendItem>
					<div className={cn('inline-block w-2 h-2 rounded-full', dotColor2)} />
					<span>
						{format(parseISO(start_date), 'dd.MM.yyyy')} -{' '}
						{end_date && format(parseISO(end_date), 'dd.MM.yyyy')}
					</span>
				</LegendItem>
			</Legend>
		</StyledCardWrapper>
	)
}

export default StatisticsCard
